import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { GraphqlService } from '../graphql/graphql.service';

const ALLOWED_ROLES = ['admin', 'supervisor'];

export const supervisorGuard = () => {
  const msalService = inject(MsalService);
  const graphqlService = inject(GraphqlService);
  const router = inject(Router);

  const account =
    msalService.instance.getActiveAccount() ??
    msalService.instance.getAllAccounts()[0];

  if (!account) {
    return router.createUrlTree(['/auth/login']);
  }

  return graphqlService.verifyUser(account.username).pipe(
    map(user => {
      if (!user || !ALLOWED_ROLES.includes(user.role?.toLowerCase() ?? '')) {
        return router.createUrlTree(['/auth/login'], { queryParams: { error: 'unauthorized' } });
      }
      return true;
    }),
    catchError(() => of(router.createUrlTree(['/auth/login'], { queryParams: { error: 'auth_failed' } }))),
  );
};
